import { Menu, Plus } from 'lucide-react';

/**
 * Même bandeau que celui de l'admin (voir Sidebar.jsx) : mêmes hauteur,
 * marges et taille de logo. Seule différence assumée, le bouton d'ajout.
 */
export default function MerchantHeader({
  activeTab,
  onOpenMenu,
  onOpenNewOrder,
  onOpenAddProduct,
}) {
  const showAction = activeTab === 'commandes' || activeTab === 'produits';
  const handleAction = activeTab === 'commandes' ? onOpenNewOrder : onOpenAddProduct;

  return (
    <div style={{
      // Même pose que la topbar admin : fixée en haut du viewport plutôt que
      // posée dans le flux d'une fenêtre verrouillée. z-index 30, soit sous le
      // voile (40) et le tiroir (50), qui doivent continuer à passer dessus.
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 30,
      background: 'linear-gradient(90deg, #07162d 0%, #112c52 100%)',
      padding: '0 16px',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      boxShadow: '0 2px 16px rgba(0,0,0,0.25)',
    }}>
      {/* Menu */}
      <button
        onClick={onOpenMenu}
        style={{
          width: '36px', height: '36px',
          background: 'rgba(255,255,255,0.08)',
          border: 'none',
          cursor: 'pointer',
          color: 'white',
          borderRadius: '9px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
          transition: 'background 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
      >
        <Menu size={18} />
      </button>

      {/* Le sélecteur de boutique vivait ici, ce qui forçait le logo à mi-taille
          et le rendait délavé. Il est passé à côté du titre de page. */}
      <img
        src="/logo-wakaana.png"
        alt="Wakaana Express"
        style={{ height: '68px', maxWidth: '180px', objectFit: 'contain' }}
      />

      {/* Bouton "+" ou spacer */}
      {showAction ? (
        <button
          onClick={handleAction}
          style={{
            width: '36px', height: '36px',
            background: '#c53a2d',
            border: 'none',
            cursor: 'pointer',
            color: 'white',
            borderRadius: '9px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
            boxShadow: '0 3px 10px rgba(197,58,45,0.4)',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
        >
          <Plus size={18} />
        </button>
      ) : (
        <div style={{ width: '36px' }} />
      )}
    </div>
  );
}
